<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="子站集合">
              <a-select show-search :filter-option="filterOption" mode="multiple" v-model="where.keyword.dataZone"
                allowClear @change="changeDataZone">
                <a-select-option :value="subinfo.id" v-for="(subinfo, index) in where.subsites"
                  :key="index + '--' + subinfo.name">{{ subinfo.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="用户信息">
              <a-input placeholder="请输入用户名/姓名/身份证号/手机号" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="课程名称">
              <a-input placeholder="请输入" v-model="where.keyword.courseName" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="缴费日期">
              <a-range-picker format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onTimeChange" />
            </a-form-item>
          </a-col>

        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="单位名称">
              <a-input placeholder="请输入" v-model="where.keyword.company" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="所在地区">
              <a-cascader :options="where.areas" placeholder="请选择所在地区" change-on-select @change="onAreachange"
                :fieldNames="{ label: 'name', value: 'name', children: 'children' }" />
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="课程来源">
              <a-select v-model="where.keyword.coursefrom" allowClear @change="courseFromClear">
                <a-select-option :value="info.id" v-for="(info, index) in where.courseFromlist" :key="index">{{
                  info.itemName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="完成度">
              <a-select show-search v-model="where.keyword.finish" :filter-option="filterOption" allowClear @change="finishClear">
                <a-select-option v-for="info in where.finishList" :key="info.name" :value="info.value">{{ info.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="最后学习时间">
              <a-range-picker @change="onLastTimeChange" />
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="课程类型">
              <a-select v-model="where.keyword.natureType" :filter-option="filterOption" allowClear
                @change="natureTypeChange">
                <a-select-option :value="item.value" v-for="item in where.natureTypeList" :key="item.name + item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="课程分类">
              <a-cascader :disabled="statusList.groupDisableStatus" placeholder="请选择" :options="treeData"
                @change="treeChange" allowClear :fieldNames="{ label: 'name', value: 'id', children: 'children' }" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="用户组">
              <a-select :disabled="statusList.groupDisableStatus" show-search v-model="where.keyword.groupId"
                :filter-option="filterOption" allowClear @change="groupChanged">
                <a-select-option :value="info.id" v-for="(info, index) in where.grouplist" :key="index">{{ info.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="主管部门">
              <a-select :disabled="statusList.adminStatus" show-search v-model="where.keyword.administration"
                :filter-option="filterOption" allowClear @change="administrationChanged">
                <a-select-option :value="info.itemName" v-for="(info, index) in where.administrationList"
                  :key="index + info.itemName">{{ info.itemName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="课程年份">
              <a-select v-model="where.keyword.year"  mode="multiple" allowClear>
                <a-select-option :value="item" v-for="item in year.menu" :key="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="注册方式">
              <a-select v-model="where.keyword.sourceType" :filter-option="filterOption" allowClear
                        @change="howToRegisterChange">
                <a-select-option :value="item.value" v-for="item in where.howToRegisterList" :key="item.name + item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="2" :style="{ textAlign: 'left' }">
            <a-button type="primary" @click="searchList">搜索</a-button>
          </a-col>
        </a-row>
        <a-row :gutter="24">

        </a-row>
      </a-form>
    </div>
    <div class="pxkeji-right-box">
      <a-button type="primary" @click="exportData" style="margin-bottom: 10px;" v-btnlimit="'子站学习数据-导出'">导出记录</a-button>

      <div style="float: right">
        <span>共有：{{list.pagination.total}}条数据 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 人数：{{ list.renshu }}</span>
      </div>
      <a-table :columns="list.columns" rowKey="id" :pagination="list.pagination" @change="pageChange"
        :dataSource="list.datas" :loading="isloading" :locale="{ emptyText: '请按需求筛选后，点击搜索' }">
        <span slot="dataZoneName" slot-scope="dataZoneName">
          <span>{{ dataZoneName ? dataZoneName : '总站数据' }}</span>
        </span>
        <span slot="action" slot-scope="info">
          <pxkeji-btn name="学习明细" size="small" @click="showInfo(info.courseId, info.userId, info.dataZone)"
            type="primary" />
          <a-divider type="vertical" />
          <pxkeji-btn name="课程明细" size="small" @click="showCourse(info.userId, info.dataZone)" type="primary" />
        </span>
        <span slot="sourceType" slot-scope="sourceType">
          <span v-if="sourceType == 0">个人注册</span>
          <span v-else>系统导入</span>
        </span>
        <span slot="status" slot-scope="status">
          <a-tag v-if="status == 0" color="red">禁用</a-tag>
          <a-tag v-else color="green">启用</a-tag>
        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>共有：{{ list.pagination.total }}条数据</span>
        </div>
      </div>

      <a-modal :title="studyDetail.title" v-model="studyDetail.visible" width="60%" :footer="false" destroyOnClose
        :maskClosable="false">
        <Info @callbackMethod="save" :id="studyDetail.id" :uid="studyDetail.uid" :dataZone="studyDetail.dataZone" />
      </a-modal>
      <a-modal :title="course.title" v-model="course.visible" width="60%" :footer="false" destroyOnClose
        :maskClosable="false">
        <course @callbackMethod="save" :uid="course.uid" :dataZone="course.dataZone" />
      </a-modal>
    </div>
  </div>
</template>
<script>
var that;
import Info from "./components/studyInfo.vue"; //学习明细
import course from "../recordStatistics/courseInfo.vue"; //课程明细

const columns = [
  {
    dataIndex: "dataZoneName",
    key: "dataZoneName",
    align: "center",
    title: "站点",
    scopedSlots: { customRender: "dataZoneName" }
  },
  {
    dataIndex: "userName",
    key: "userName",
    align: "center",
    title: "用户姓名",
  },
  {
    dataIndex: "idCard",
    key: "idCard",
    align: "center",
    title: "身份证号",
  },

  {
    dataIndex: "courseType",
    key: "courseType",
    align: "center",
    title: "课程分类"
  },
  {
    dataIndex: "courseName",
    key: "courseName",
    align: "center",
    title: "课程名称"
  },
  {
    dataIndex: "hourCount",
    key: "hourCount",

    align: "center",
    title: "学时"
  },
  {
    dataIndex: "year",
    key: "year",

    align: "center",
    title: "年份"
  },
  {
    dataIndex: "lastTime",
    key: "lastTime",
    align: "center",
    title: "学习时间"
  },
  {
    dataIndex: "percent",
    key: "percent",
    align: "center",
    title: "学习记录",
  },

  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];
export default {
  name: "userlist",
  data() {
    return {
      isloading: false,
      /** 列表显示模块 */
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        },
        renshu:0,
        xueshi:0
      },
      statusList: {
        groupDisableStatus: true,//用户组状态控制器
        adminStatus: true,//主管部门状态控制器
        exportButStatus: true //导出按钮状态控制器
      },
      //课程明细
      course: {
        visible: false,
        uid: 0,
        dataZone: ''
      },
      //学习明细弹窗
      studyDetail: {
        visible: false,
        id: 0,
        title: "",
        uid: 0,
        dataZone: '',
      },
      //课程分类
      treeData: [],
      /** 查询条件模块 */
      where: {
        //向后端传递的查询数据
        keyword: {
          name: "",//用户信息
          courseName: "",//课程名称
          dataZone: [],//子站ID
          startTime: "",//缴费开始时间
          endTime: "",//缴费结束时间
          company: "",//单位名称
          administration: "",//主管部门
          startLastTime: "",//最后学习开始时间
          endLastTime: "",//最后学习结束时间
          finish: "",//完成度
          groupId: "",//用户组
          province: '',//省
          city: '',//市
          area: '',//区
          type: '',//课程分类
          year:[],
          natureType: "",//课程类型
          howToRegister: "",//注册方式
          coursefrom: "",//课程来源
          pageNow: 1,//默认首页
          pageSize: 10//默认查询长度

        },
        /*************以下页面展示的option数据***************/
        //课程来源
        courseFromlist: [],
        //课程类型
        natureTypeList: [{ value: "1", name: '公需课' }, { value: "2", name: '专业课' }],
        //注册方式
        howToRegisterList: [{ value: "0", name: '个人注册' }, { value: "2", name: '系统导入' }],
        //站点集合
        subsListOption: [],
        //用户主
        grouplist: [],
        //主管部门
        administrationList: [],
        //区域列表
        areas: [],
        //子站集合
        subsites: [],
        //完成度
        finishList: [{ value: "1", name: "未学习" }, { value: "2", name: "学习中" }, { value: "3", name: "已完成" }],
      },
      year: {
        menu: ["2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025", "2026", "2027", "2028", "2029", "2030"],
      },
    };
  },
  components: {
    Info: Info,
    course: course
  },
  mounted: function () {
    this.$nextTick(function () {
      this.where.areas = this.$api.city.city;
      that = this;
      this.getDictionaryItem();
      this.getSubsites();
      //this.getCoursePageList();
      this.getcourseFromlist();
    });
  },
  watch: {
    selectRows: function () {
    }
  },
  methods: {
    //获取课程来源
    getcourseFromlist() {
      this.$api.dictionaryItem
        .getDictionaryItem(2)
        .then((res) => {
          if (res.errorCode == this.$msg.responseCode.success) {
            this.where.courseFromlist = res.data;
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
        });
    },
    //获取分类列表
    getTree() {
      this.$api.courseType
        .getTreeByColumnId("", "", "", this.where.keyword.dataZone[0])
        .then((res) => {
          if (res.errorCode == this.$msg.responseCode.success) {
            var allData = [
              {
                name: "根目录",
                parentid: 0,
                id: 0,
                children: res.data,
              },
            ];
            this.treeData = allData;
            this.info.type = [0];
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
        });
    },
    //课程分类选择
    treeChange(val) {
      // console.log(val)
      if (val.length > 0) {
        this.where.keyword.type = val[Number(val.length) - 1];
      } else {
        this.where.keyword.type = "";
      }
    },
    //课程类型
    natureTypeChange(val) {
      if (val) {
        this.where.keyword.natureType = val;
      } else {
        this.where.keyword.natureType = "";
      }
    },
    //注册方式
    howToRegisterChange(val) {
      if (val) {
        this.where.keyword.sourceType = val;
      } else {
        this.where.keyword.sourceType = "";
      }
    },
    /**按钮区 */
    searchList() {//点击搜索按钮
      this.list.pagination.current = 1;
      this.where.keyword.pageNow = 1;
      this.getCoursePageList();
    },
    //过滤搜索结果 输入关键字出相应的搜索结果
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },

    /**初始化数据区域 */
    //初始化学习列表统计
    getCoursePageList() {
      this.isloading = true;
      var param = this.where.keyword
      this.$api.recordStatistics
        .getPageListByDataZone(param)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
            this.list.renshu = res.data.renshu;
            this.list.xueshi = res.data.xueshi;
            for (var i = 0; i < this.list.datas.length; i++) {
              this.list.datas[i].id = i;
              var info = this.list.datas[i];
              info.percent = String((info.percent * 100)).substring(0, 4) + '%';
            }
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch((r) => {
          this.isloading = false;
          // console.log(r);
        });
    },
    //初始化用户主
    getgrouplist() {
      this.$api.usergroup
        .getGroupIdByDataZone({ dataZone: this.where.keyword.dataZone[0] })
        .then(res => {
          if (res.errorCode == this.$msg.responseCode.success) {
            this.where.grouplist = res.data;
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.$message.error();
        });
    },
    //获取主管部门列表
    getDictionaryItem() {
      this.$api.dictionaryItem.tree(23).then((res) => {
        if (res.errorCode == this.$msg.responseCode.success) {
          this.where.administrationList = res.data;
        } else {
          that.$message.error(res.errorMsg);
        }
      });
    },
    //获取子站集合
    getSubsites() {
      this.$api.area.getAllSubsitesList().then((res) => {
        if (res.errorCode == this.$msg.responseCode.success) {
          this.where.subsites = res.data
        } else {
          that.$message.error(res.errorMsg);
        }
      })
        .catch(() => {
          that.$message.error();
        });
    },
    //导出数据
    exportData() {
      window.location.href = this.$api.recordStatistics.exportStudyByDataZone(this.where.keyword);
    },
    /**选项区*/
    //缴费日期选择 开始时间，结束时间
    onTimeChange(date, dateString) {
      this.where.keyword.startTime = dateString[0];
      this.where.keyword.endTime = dateString[1];
    },
    //最后学习日期选择
    onLastTimeChange(date, dateString) {
      this.where.keyword.startLastTime = dateString[0];
      this.where.keyword.endLastTime = dateString[1];
    },
    // 选择区域 省市县
    onAreachange(v) {
      this.where.keyword.province = v[0] ? v[0] : "";
      this.where.keyword.city = v[1] ? v[1] : "";
      this.where.keyword.area = v[2] ? v[2] : "";
    },
    //赋值用户组
    groupChanged(v) {
      this.where.keyword.groupId = v ? v : ''
    },
    //赋值主管部门
    administrationChanged(v) {
      this.where.keyword.administration = v ? v : "";
    },
    //清除动作
    sourceTypeChange(v) {
      this.where.keyword.sourceType = v > 0 ? v : v == 0 ? 0 : "";
    },
    //切换页码
    pageChange(v) {
      this.list.pagination.current=v.current
      this.where.keyword.pageNow = v.current
      this.getCoursePageList();
    },
    //查看学习详情
    showInfo(id, uid, dataZone) {
      this.studyDetail.visible = true;
      this.studyDetail.id = id;
      this.studyDetail.uid = uid;
      this.studyDetail.dataZone = dataZone;
    },
    //查看课程明细
    showCourse(uid, dataZone) {
      this.course.visible = true;
      this.course.uid = uid;
      this.course.dataZone = dataZone;
    },
    //子站选择项目变化
    changeDataZone(v, i) {
      this.list.datas = [];
      this.list.pagination.total = 0;
      this.where.grouplist = [];
      this.where.keyword.groupId = "";
      if (v && v.length == 1) {
        this.getgrouplist();
        this.getTree();
        this.statusList.groupDisableStatus = false;
        this.statusList.adminStatus = false;
        this.statusList.exportButStatus = false;
      } else {
        this.statusList.groupDisableStatus = true;
        this.statusList.adminStatus = true;
        this.statusList.exportButStatus = true;
        //this.where.keyword.dataZone = "";
      }
    },
    //取消来源
    courseFromClear(val) {
      if (!val) {
        this.where.keyword.coursefrom = "";
      }
    },
    //取消完成度
    finishClear(val) {
      if (!val) {
        this.where.keyword.finish = "";
      }
    },
    //子组件传值
    save() {
      this.addedit.visible = false;
      this.getCoursePageList();
    },
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.cang_sta {
  text-align: center;
}

.cang_sta img {
  width: 35px;
}
</style>

